import React from 'react'
import './StoryHeader.css'
import StoryTerm from './StoryTerm'

type Props = {
  info: storyInfo
}
export default function StoryHeader(props: Props) {
  return (
    <header>
      <div>
        {
          props.info.image && <img src={props.info.image} alt="" />
        }
      </div>
      <h1>{props.info.title}</h1>
      {0 < props?.info?.start?.unix() &&
        props?.info?.start?.unix() <= props?.info?.end?.unix() &&
        <StoryTerm start={props.info.start} end={props.info.end} />
      }
    </header>
  )
}
